module.exports = __webpack_public_path__ + "img/head-draw.21093216.svg";